import { useContext, useEffect, useCallback } from "react";
import useCartStore from "../store/cartStore";
import { AuthContext } from "../contexts/AuthContext";
import api from "../services/api";
import { isClientUser } from "../utils/userRole";

// O carrinho vive no banco — não há localStorage nem cache local.
// Este hook busca o carrinho salvo ao montar (o backend é sempre a fonte de
// verdade, para o dispositivo que for) e salva no backend imediatamente a
// cada alteração feita pelo usuário.
export default function useCart(clientHash, sellerId) {
  const { user } = useContext(AuthContext);
  const { cart, totalCartValue, setCart } = useCartStore();

  useEffect(() => {
    if (!isClientUser(user)) return;

    api
      .get("/cart", { params: { _t: Date.now() } })
      .then((response) => {
        setCart(response.data?.products || []);
      })
      .catch(() => {});
  }, [user, setCart]);

  // Salva o carrinho (estado atual do store) no backend.
  const persistCart = useCallback(() => {
    if (!isClientUser(user) || !clientHash) return;

    const { cart: currentCart, totalCartValue: getTotal } =
      useCartStore.getState();

    api
      .post("/cart", {
        products: currentCart,
        totalValue: getTotal(),
        companyHash: clientHash,
        sellerId,
      })
      .catch(() => {});
  }, [user, clientHash, sellerId]);

  const addToCart = (item) => {
    useCartStore.getState().addToCart(item);
    persistCart();
  };

  const removeFromCart = (id) => {
    useCartStore.getState().removeFromCart(id);
    persistCart();
  };

  const decrementFromCart = (id, color, size) => {
    useCartStore.getState().decrementFromCart(id, color, size);
    persistCart();
  };

  const setQuantity = (item) => {
    useCartStore.getState().setQuantity(item);
    persistCart();
  };

  const clearCart = () => {
    useCartStore.getState().clearCart();
    persistCart();
  };

  return {
    cart,
    totalCartValue,
    addToCart,
    removeFromCart,
    decrementFromCart,
    setQuantity,
    clearCart,
  };
}
